export default "__VITE_ASSET__bb6624bd__"